import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "titled-section__heading" }
const _hoisted_2 = { class: "header columns" }
const _hoisted_3 = { class: "section__header" }
const _hoisted_4 = { class: "titles" }
const _hoisted_5 = { class: "section__title" }
const _hoisted_6 = { class: "section__subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "column is-3 section__actions"
}
const _hoisted_8 = { class: "titled-section__content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'TitledSection',
  props: {
  alignContentLeft: {
    type: Boolean,
    default: false,
  },
  iconColour: {
    type: String,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["titled-section container", { 'has-icon': !!_ctx.$slots.icon, 'left-gutter': !!_ctx.$slots.icon && !__props.alignContentLeft }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["column", !!_ctx.$slots.actions ? 'is-9' : 'is-12'])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.$slots.icon)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["section__icon", !__props.iconColour ? 'section__icon__default' : '']),
                  style: _normalizeStyle({ color: __props.iconColour })
                }, [
                  _renderSlot(_ctx.$slots, "icon")
                ], 6))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "title")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "subtitle")
              ])
            ])
          ])
        ], 2),
        (!!_ctx.$slots.actions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "actions")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})